// Global actions
export let SHOW_ERROR_TOAST = "SHOW_ERROR_TOAST";
export let RESET_TOAST = "RESET_TOAST";
export let UPDATE_PAGE_TITLE = "UPDATE_PAGE_TITLE"
export let SET_ERROR_LOG = "SET_ERROR_LOG"


// Institute Actions
export let GET_INSTITUTE_LIST = "GET_INSTITUTE_LIST";


// Branch actions
export let GET_INSTITUTE_ALL_BRANCHES = "GET_INSTITUTE_ALL_BRANCHES";
export let GET_FORMS = "GET_FORMS";
export let GET_BRANCH_DETAILS = "GET_BRANCH_DETAILS";
export let GET_COURSE_LIST = "GET_COURSE_LIST";
export let GET_STATES = "GET_STATES";
export let GET_CITY = "GET_CITY";
export let GET_CASTES = "GET_CASTES";
export let GET_ACADEMIC_YEAR = "GET_ACADEMIC_YEAR";
export let RESET_BRANCH_DATA = "RESET_BRANCH_DATA";
export let GET_TALUKA = "GET_TALUKA";
export let RESET_CITYLIST = "RESET_CITYLIST";
export let RESET_TALUKALIST = "RESET_TALUKALIST";
export let GET_DOCUMENTLIST = "GET_DOCUMENTLIST";
export let GET_SUB_CASTES = "GET_SUB_CASTES";
export let GET_SUBJECT_PREFERENCE_LIST = "GET_SUBJECT_PREFERENCE_LIST";








//Admission Actions

export let SUBMIT_SINGLE_STEP = "SUBMIT_SINGLE_STEP";
export let LOGIN = "LOGIN";
export let RESET_LOGIN_DATA = "RESET_LOGIN_DATA";
export let INIT_PAYMENT = "INIT_PAYMENT";
export let RESET_ADMISSION_DATA = "RESET_ADMISSION_DATA";
export let GET_PAYMENT_STATUS = "GET_PAYMENT_STATUS";
export let SUBMIT_PRIMARY_FROM_2 = "SUBMIT_PRIMARY_FROM_2";
export let BASIC_PROFILE = "BASIC_PROFILE";


//Document Actions
export let DOCUMENT_LIST = "DOCUMENT_LIST";



/**
 * Add all of your actions above these functions.
 *
 * @export
 * @param {*} action
 * @returns
 */
export function pending(action) {
    return action + "_PENDING";
}

export function fulfilled(action) {
    return action + "_FULFILLED";
}

export function rejected(action) {
    return action + "_REJECTED";
}